"use strict";
/**
 * @file Created on 24.07.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDoc_1 = require("../../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NWindowWrapper =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NWindowWrapper, _NotificationDoc_1$No);

  /**
   * @param promoId
   * @param promoName
   * @param promoExternalId
   * @param promoDateFrom
   * @param promoDateTo
   * @param promoStartWeek
   * @param promoStoreSpecification
   * @param id
   * @param name
   * @param externalId
   * @param workflowState
   * @param windowTypeId
   * @param windowType
   * @param portfolioId
   * @param portfolio
   * @param themeId
   * @param theme
   * @param dateFrom
   * @param dateTo
   * @param priceValidityStart
   * @param priceValidityEnd
   * @param startWeek
   * @param ownedBy
   * @param documentType
   * @param document
   */
  function NWindowWrapper( // Promotion attributes
  promoId, promoName, promoExternalId, promoDateFrom, promoDateTo, promoStartWeek, promoStoreSpecification, // Window attributes
  id, name, externalId, workflowState, windowTypeId, windowType, portfolioId, portfolio, themeId, theme, dateFrom, dateTo, priceValidityStart, priceValidityEnd, startWeek, ownedBy) {
    var _this;

    var documentType = arguments.length > 23 && arguments[23] !== undefined ? arguments[23] : null;
    var document = arguments.length > 24 && arguments[24] !== undefined ? arguments[24] : null;

    _classCallCheck(this, NWindowWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NWindowWrapper).call(this));
    _this.promoId = promoId;
    _this.promoName = promoName;
    _this.promoExternalId = promoExternalId;
    _this.promoDateFrom = promoDateFrom;
    _this.promoDateTo = promoDateTo;
    _this.promoStartWeek = promoStartWeek;
    _this.promoStoreSpecification = promoStoreSpecification;
    _this.id = id;
    _this.name = name;
    _this.externalId = externalId;
    _this.workflowState = workflowState;
    _this.windowTypeId = windowTypeId;
    _this.windowType = windowType;
    _this.portfolioId = portfolioId;
    _this.portfolio = portfolio;
    _this.themeId = themeId;
    _this.theme = theme;
    _this.dateFrom = dateFrom;
    _this.dateTo = dateTo;
    _this.priceValidityStart = priceValidityStart;
    _this.priceValidityEnd = priceValidityEnd;
    _this.startWeek = startWeek;
    _this.ownedBy = ownedBy;
    _this.documentType = documentType;
    _this.document = document;
    return _this;
  }

  return NWindowWrapper;
}(NotificationDoc_1.NotificationDoc);

exports.NWindowWrapper = NWindowWrapper;